<template>
    <div>
        <div
            :class="isCollapse ? 'board-store-select-close' : 'board-store-select-open'"
            class="absolute board-store-select">
            <el-select
                class="pr-2"
                v-model="storeId"
                v-on:change="handleRefresh()"
                placeholder="$t('Common.store_placeholder')">
                <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="Number(item.id)">
                </el-option>
            </el-select>
        </div>
        <el-card class="dash-board" v-loading="loading">
            <!-- <div class=""> -->
                <div class="board-container">
                    <!-- 图表 -->
                    <div class="board-chart flex justify-between">
                        <div class="chart-item">
                            <div class="chart-figure">
                                <p class="num">{{ average }}</p>
                                <p class="text">{{ $t('Board.Flow.all') }}</p>
                                <h3 class="title">{{ $t('Board.Flow.title') }}</h3>
                            </div>
                            <div class="init-chart-div">
                                <div class="chart-show" ref="chart_visit"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 状态 -->
                    <div class="board-status flex">
                        <!-- 预约 -->
                        <status-list ref="status" />
                        <!-- 团课课表 -->
                        <team-list ref="team" />
                        <!-- 私教预约 -->
                        <personal-list ref="personal" />
                    </div>
                </div>
            <!-- </div> -->
        </el-card>
    </div>
</template>

<script>
import echarts from 'echarts';
import StatusList from '@/components/widget/Board/StatusList.vue';
import TeamList from '@/components/widget/Board/TeamList.vue';
import PersonalList from '@/components/widget/Board/PersonalList.vue';

export default {
    components: {
        StatusList,
        TeamList,
        PersonalList,
    },
    data() {
        return {
            storeId: null,
            stores: [],
            chartData: [],
            average: 0,
            loading: false,
        };
    },
    created() {
        this.$nextTick(() => {
            this.fetchStore();
        });
    },
    computed: {
        isCollapse() {
            return this.$store.state.isCollapse;
        },
    },
    methods: {
        // 门店选择
        async fetchStore() {
            await API.get('store/list').then(res => {
                this.stores = res;
                this.storeId = res[0].id;
            });
            this.fetchData();
            this.fetchChartData();
        },
        handleRefresh() {
            this.fetchChartData();
            this.fetchData();
        },
        async fetchChartData() {
            this.loading = true;
            await API.get('entrance/client-flow', {
                params: {
                    storeId: this.storeId,
                },
            }).then(res => {
                this.chartData = res;
                let sum = 0;
                for (let i = 0; i < this.chartData.length; i++) {
                    sum = sum + res[i].amount;
                }
                if (!sum) this.average = 0;
                else if (0 < (sum / 30) < 1) this.average = 1;
                else this.average = Math.round(sum / 30);
            });
            this.loading = false;
            this.initVisitChart();
        },
        fetchData() {
            this.$refs.team.fetchData(this.storeId);
            this.$refs.personal.fetchData(this.storeId);
            this.$refs.status.fetchData(this.storeId);
        },
        initVisitChart() {
            this.$refs.chart_visit.style.height = '100%';
            this.$refs.chart_visit.style.width = '100%';
            const myChart = echarts.init(this.$refs.chart_visit);

            const dateList = this.chartData.map(item => item.date);
            const valueList = this.chartData.map(item => item.amount);
            const datalabel= this.chartData.map(item => item.amountVip);
            const option = {
                color: ['#6ECBF6'],
                tooltip: {
                    trigger: 'axis',
                },
                xAxis: {
                    data: dateList,
                    show: false,
                },
                yAxis: {
                    splitLine: {show: false},
                    show: false,
                },
                grid: {
                    left: '-3%',
                    right: '-1%',
                    top: '1%',
                    bottom: '-4.3%',
                    containLabel: true,
                },
                series: [{
                    name: "总会员",
                    type: 'line',
                    showSymbol: false,
                    itemStyle: {
                        normal: {
                            barBorderRadius: 5,
                        },
                    },
                   data: valueList,
                    areaStyle: {},


                },
                    {
                        name: "付费会员",
                        type: 'line',
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 5,
                            },
                        },
                        data: datalabel,
                        areaStyle: {},

                    }
                ]
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="scss">
.board-store-select {
    z-index: 2;
    top: 14px;

    &.board-store-select-close {
        left: 210px;
        transition: all .5s;
    }

    &.board-store-select-open {
        left: 403px;
        transition: all .4s;
    }
}
.board-container {
    width: 100%;
    min-width: 1070px;
}
// 图表
.board-chart {
    width: 100%;
    margin-bottom: 15px;
}
.chart-item {
    width: 100%;
    height: 300px;
    background: #fff;
    border-radius: 7px;
    overflow: hidden;

    &:first-child {
        margin-left: 0;
    }
}
.dash-board {
    background: #f0f2f5;
    border: none !important;
    box-shadow: none !important;
    .el-card__body {
        padding: 0 !important;
    }
    p, h3 {
        margin: 0;
    }
}
.chart-figure {
    position: relative;
    padding: 20px 20px 0 20px;
    line-height: 1.3;
    margin-bottom: 20px;

    .num {
        font-size: 30px;
        color: #212121;
    }
    .text {
        font-size: 12px;
        color: #212121;
    }
    .title {
        position: absolute;
        right: 20px;
        top: 20px;
        font-size: 42px;
        color: #e5e5e5;
        width: auto;
    }
}
.init-chart-div {
    height: calc(100% - 86px);
}
.flex-column {
    flex-direction: column;
}
.status-list-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #f0f0f0;
    background-size: cover;
    background-position: center;
}
</style>
